module.exports = __webpack_public_path__ + "img/w3_circle_pause_black.9aa21622.png";